import type { DuoColorSwatch } from '@frontend/libs/types/product'

import { XMarkIcon } from '@heroicons/react/24/outline'
import { Button, cn, Tooltip } from '@nextui-org/react'

import type { SwatchProps } from './Swatch'

export type DuoColorSwatchProps = {
  item: DuoColorSwatch
} & Pick<SwatchProps, 'onClick' | 'option' | 'value'>

export function DuoColorSwatch({
  item,
  onClick,
  option,
  value,
}: Readonly<DuoColorSwatchProps>) {
  const isSelected = value === item.slug
  const isAvailable = item.isAvailable

  const button = (
    <Button
      className={cn(
        `h-7 w-7 min-w-0 border border-primary/30 p-[1px] hover:border-primary/50`,
        {
          'border-primary': isSelected,
          'opacity-25': !isAvailable,
        },
      )}
      key={item.slug}
      onClick={() => onClick({ [option.slug]: item.slug })}
      radius="none"
      size="sm"
      type="button"
      variant="light"
    >
      <div className="relative flex h-full w-full items-center justify-center">
        <div className="grid h-full w-full grid-cols-2">
          <span style={{ backgroundColor: item.colors[0] as string }}></span>
          <span style={{ backgroundColor: item.colors[1] as string }}></span>
        </div>
        {!isAvailable && <XMarkIcon className="h-7 w-7 text-red-600" />}
      </div>
    </Button>
  )

  if (item.enableTooltip) {
    return (
      <Tooltip
        color="primary"
        content={item.label}
        key={item.slug}
        showArrow={true}
      >
        {button}
      </Tooltip>
    )
  }

  return button
}

export default DuoColorSwatch
